export enum TimeRangeFilter {
  PREVIOUS_MONTH = 'previousMonth',
  PAST_3_MONTHS = 'past3Months',
  YEAR_TO_DATE = 'yearToDate',
  PAST_12_MONTHS = 'past12Months',
  LAST_CALENDAR_YEAR = 'lastCalendarYear',
  MONTH_TO_DATE = 'monthToDate',
  PAST_30_DAYS = 'past30Days',
  PAST_2_YEARS = 'past2Years',
  PAST_3_YEARS = 'past3Years',
}
